/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Container from "../Container/Container";
import LegalbirdLoader from "../ContentLoader/LegalbirdLoader";
import _map from "lodash/map";
import _slice from "lodash/slice";
import Button from "@mui/material/Button";
import { Replay } from "@mui/icons-material";
import documentsStyle from "./documentsStyle";
import { fetchCollection, queryKeys } from "../../services/reactQuery/reactQueryService";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { AbstractCase } from "../../types/Entities/AbstractCase";
import { Divider } from "@mui/material";
import MediaObjectRow from "../MediaObject/MediaObjectRow";

type DocumentsProps = {
  product: AbstractCase;
};

const Documents = ({ product }: DocumentsProps) => {
  const queryClient = useQueryClient();
  const [showAll, setShowAll] = useState(false);
  const urlParams = { product: product.name, productId: product.id };
  const mediaObjectCollectionKey = queryKeys.collection("/media_objects", urlParams);
  const { data: mediaObjectsCollection } = useQuery({
    queryKey: mediaObjectCollectionKey,
    queryFn: () => fetchCollection("/media_objects", urlParams)
  });
  const moreDocumentsThreshold = 2;

  const fetchMediaObjectCollection = () =>
    queryClient.invalidateQueries({
      queryKey: mediaObjectCollectionKey,
    });

  if (!product || !mediaObjectsCollection) {
    return (
      <Container sx={{ width: 250 }}>
        <LegalbirdLoader />
      </Container>
    );
  }

  if (mediaObjectsCollection.length < 1) {
    return (
      <Grid container sx={{
        justifyContent: "center"
      }}>
        <Grid sx={documentsStyle.placeholderText}>
          Bisher sind noch keine Dokumente vorhanden
        </Grid>
        <Grid size={12} />
        <Grid sx={documentsStyle.gridSpacing}>
          <Button onClick={fetchMediaObjectCollection} startIcon={<Replay />}>
            Aktualisieren
          </Button>
        </Grid>
      </Grid>
    );
  }

  const mediaObjects = showAll ? mediaObjectsCollection : _slice(mediaObjectsCollection, 0, moreDocumentsThreshold);

  return (
    <>
      <Grid container>
        {_map(mediaObjects, (mediaObject) => {
          return (
            <Grid key={mediaObject.id} size={12}>
              <Divider />
              <MediaObjectRow mediaObject={mediaObject} />
            </Grid>
          );
        })}
      </Grid>
      {mediaObjectsCollection.length > moreDocumentsThreshold && (
        <>
          <Divider />
          <Button
            fullWidth
            color={"primary"}
            onClick={() => {
              setShowAll(!showAll);
            }}
          >
            {showAll ? "Weniger anzeigen" : "Alle anzeigen"}
          </Button>
        </>
      )}
    </>
  );
};

export default Documents;
